import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RemoveCircleOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"remove_circle_outline"}/>
}
